<page-title [title]="title"></page-title>
<form [formGroup]="form">
  <div class="col-xs-12 col-md-3">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Especialista</mat-label>
      <mat-select formControlName="practitioner_id">
        <mat-option></mat-option>
        <mat-option *ngFor="let item of practitioners" [value]="item.practitioner_id">
          {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-xs-12 col-md-3">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Especialidade</mat-label>
      <mat-select formControlName="healthcareservice">
        <mat-option></mat-option>
        <mat-option *ngFor="let healthcareservice of healthcareservicesname" [value]="healthcareservice.name">
          {{ healthcareservice.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-xs-12 col-md-3 btBuscar">
    <button mat-flat-button color="primary" (click)="pesquisar()" [disabled]="loading">Buscar</button>
  </div>
</form>

<div class="col-xs-12 alert">
  <page-alert [message]="notFoundMessage" *ngIf="encounters.length == 0" alertClass="alert-warning"></page-alert>
</div>

<page-scheduler [encounters]="encounters"></page-scheduler>
